const ROOT = '#swoo-gift-card-pro';
const CLASS_OPEN = 'swoo-gift-card-pro--open';
const CLASS_APPLIED = 'swoo-gift-card-pro--applied';
const CLASS_ERROR = 'swoo-gift-card-pro--error';
const CLASS_LOADING = 'swoo-gift-card-pro--loading';
const ATTRIBUTE_EXPANDED = 'aria-expanded';
const KEY_ENTER = 'Enter';

/**
 * The gift card field on the checkout page: opens and closes the field, applies and removes a gift card and keeps
 * the amounts in step with the order total.
 */
export default {
    init() {
        this.$root = jQuery(ROOT);
        if (this.$root.length === 0) {
            return;
        }

        this.$toggle = this.$root.find('.swoo-gift-card-pro__toggle');
        this.$input = this.$root.find('#swoo-gift-card-pro-input');
        this.$apply = this.$root.find('#swoo-gift-card-pro-apply');
        this.$remove = this.$root.find('#swoo-gift-card-pro-remove');
        this.loading = false;

        this.$toggle.on('click', () => this.setOpen(!this.$root.hasClass(CLASS_OPEN)));
        this.$apply.on('click', () => this.apply());
        this.$remove.on('click', () => this.remove());
        this.$input.on('input', () => this.$root.removeClass(CLASS_ERROR));
        // Enter would otherwise place the order, as the field is part of the checkout form.
        this.$input.on('keydown', (event) => {
            if (event.key !== KEY_ENTER) {
                return;
            }

            event.preventDefault();
            this.apply();
        });

        jQuery(document.body).on('updated_checkout', () => this.refresh());
    },

    /**
     * @param {boolean} open
     */
    setOpen(open) {
        this.$root.toggleClass(CLASS_OPEN, open);
        this.$toggle.attr(ATTRIBUTE_EXPANDED, String(open));
        if (open) {
            this.$input.trigger('focus');
        }
    },

    apply() {
        const code = this.$input.val().trim();
        if (code === '') {
            this.showError();
            return;
        }

        this.request(code).done((response) => {
            if (!response.success) {
                this.showError();
                return;
            }

            this.showApplied(code, response.data);
            jQuery(document.body).trigger('update_checkout');
        });
    },

    remove() {
        this.request('').done(() => {
            this.$input.val('');
            this.$root.removeClass(CLASS_APPLIED);
            this.setOpen(true);
            jQuery(document.body).trigger('update_checkout');
        });
    },

    /**
     * The amount spent on the gift card follows the order total, so it is fetched again when the total may have
     * changed. The order review is only reloaded when the amount actually changed, which ends the round trip.
     */
    refresh() {
        if (!this.$root.hasClass(CLASS_APPLIED) || this.loading) {
            return;
        }

        const code = this.$input.val().trim();
        const $amountToSpend = this.$root.find('#swoo-gift-card-pro-amount-to-spend');
        const previousAmount = $amountToSpend.text().trim();
        this.request(code).done((response) => {
            if (!response.success) {
                this.$root.removeClass(CLASS_APPLIED);
                this.setOpen(true);
                this.showError();
                jQuery(document.body).trigger('update_checkout');
                return;
            }

            this.showApplied(code, response.data);
            if ($amountToSpend.text().trim() !== previousAmount) {
                jQuery(document.body).trigger('update_checkout');
            }
        });
    },

    /**
     * @param {string} code
     * @return {jQuery.jqXHR}
     */
    request(code) {
        this.setLoading(true);
        return jQuery.ajax({
            type: 'POST',
            url: wc_checkout_params.ajax_url,
            data: {
                action: 'update_gift_card',
                gift_card_code: code,
                nonce: customAjaxParams.nonce,
            },
        }).always(() => this.setLoading(false));
    },

    /**
     * @param {boolean} loading
     */
    setLoading(loading) {
        this.loading = loading;
        this.$root.toggleClass(CLASS_LOADING, loading);
        this.$apply.prop('disabled', loading);
        this.$remove.prop('disabled', loading);
    },

    showError() {
        this.$root.addClass(CLASS_ERROR);
        this.$input.trigger('focus');
    },

    /**
     * @param {string} code
     * @param {Object} amounts
     */
    showApplied(code, amounts) {
        this.$root.find('#swoo-gift-card-pro-code').text(code);
        this.$root.find('#swoo-gift-card-pro-balance-now').html(amounts.balance_now);
        this.$root.find('#swoo-gift-card-pro-balance-after-purchase').html(amounts.balance_after_purchase);
        this.$root.find('#swoo-gift-card-pro-amount-to-spend').html(amounts.amount_to_spend);
        this.$root.removeClass(CLASS_ERROR).addClass(CLASS_APPLIED);
    },
};
